import { SIZE_50 } from '@/lib/gridElements/size';
import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';
import { MediaViewerKPI } from '@/components/base/Kpi/MediaViewerKpi';
import { reelsCommentsConfig } from '../reelsComments';

// Types
import type { KpiType } from '@/lib/analytics/kpis/kpi.type';

export const reelsCommentsMVConfig: KpiType<typeof MediaViewerKpiLoader, typeof MediaViewerKPI> = {
    ...reelsCommentsConfig,
    name: 'kpi.facebook.comments',
    id: 'comments',
    tooltip: null,
    size: SIZE_50,
    loader: MediaViewerKpiLoader,
    element: MediaViewerKPI
};
